// Icons from Lucide (https://lucide.dev, ISC licence), inlined at build time from the
// lucide-static package so they are versioned with everything else and carry their licence
// header. Size and colour come from CSS: each SVG uses currentColor and 1em via `.ic`.

import home from "lucide-static/icons/home.svg?raw";
import flame from "lucide-static/icons/flame.svg?raw";
import plus from "lucide-static/icons/plus.svg?raw";
import messageCircle from "lucide-static/icons/message-circle.svg?raw";
import user from "lucide-static/icons/user.svg?raw";
import heart from "lucide-static/icons/heart.svg?raw";
import bookmark from "lucide-static/icons/bookmark.svg?raw";
import share from "lucide-static/icons/share-2.svg?raw";
import flag from "lucide-static/icons/flag.svg?raw";
import play from "lucide-static/icons/play.svg?raw";
import sparkles from "lucide-static/icons/sparkles.svg?raw";
import gamepad from "lucide-static/icons/gamepad-2.svg?raw";
import eye from "lucide-static/icons/eye.svg?raw";
import x from "lucide-static/icons/x.svg?raw";
import lock from "lucide-static/icons/lock.svg?raw";

export const icons = {
  home,
  flame,
  plus,
  messageCircle,
  user,
  heart,
  bookmark,
  share,
  flag,
  play,
  sparkles,
  gamepad,
  eye,
  x,
  lock,
} as const;

export type IconName = keyof typeof icons;

/** An inline icon wrapped so CSS can size it (`.ic svg { width: 1em; height: 1em }`). */
export function icon(name: IconName, extraClass = ""): string {
  return `<span class="ic ${extraClass}" aria-hidden="true">${icons[name]}</span>`;
}
